import KoreroText from "../../../../../KoreroText"
import { KoreroTexts } from "./Texts"

export const s3e05 =
    <div>
        {KoreroTexts.map(text => <KoreroText key={text.id} korero={text.eng} speaker={text.speaker} />)}
    </div>